import axios from '@/jslib/axios'

export const getWelcomeOfferList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/welcome/offer/list',
    params,
    ...other
  })
}

